import { render } from "./CustomerCategories.vue?vue&type=template&id=0109700e&scoped=true&ts=true"
import script from "./CustomerCategories.vue?vue&type=script&lang=ts"
export * from "./CustomerCategories.vue?vue&type=script&lang=ts"

import "./CustomerCategories.vue?vue&type=style&index=0&id=0109700e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0109700e"]])

export default __exports__